export const CONTACT_FLOW_COMPLETED_KEY = 'contactFlowCompleted';
export const GUEST_INTAKE_KEY = 'guest_intake';
export const GUEST_ONBOARDING_COMPLETED_KEY = 'guestOnboardingCompleted';
export const POST_AUTH_REDIRECT_KEY = 'postAuthRedirect';

function canUseStorage() {
  return typeof window !== 'undefined' && Boolean(window.localStorage);
}

function sanitizeAppPath(path, fallbackPath) {
  if (typeof path !== 'string' || !path.startsWith('/')) {
    return fallbackPath;
  }

  return path;
}

export function getPostAuthRedirect(defaultPath) {
  if (!canUseStorage()) {
    return defaultPath;
  }

  const storedPath = window.localStorage.getItem(POST_AUTH_REDIRECT_KEY);
  return sanitizeAppPath(storedPath, defaultPath);
}

export function setPostAuthRedirect(path) {
  if (!canUseStorage() || !path) {
    return;
  }

  window.localStorage.setItem(
    POST_AUTH_REDIRECT_KEY,
    sanitizeAppPath(path, '/dashboard')
  );
}

export function markGuestOnboardingCompleted() {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.setItem(GUEST_ONBOARDING_COMPLETED_KEY, 'true');
}

export function markContactFlowCompleted() {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.setItem(CONTACT_FLOW_COMPLETED_KEY, 'true');
}

export function hasPendingGuestIntakeSync() {
  if (!canUseStorage()) {
    return false;
  }

  return (
    window.localStorage.getItem(CONTACT_FLOW_COMPLETED_KEY) === 'true' ||
    window.localStorage.getItem(GUEST_ONBOARDING_COMPLETED_KEY) === 'true'
  );
}

export function getPendingGuestIntake() {
  if (!canUseStorage() || !hasPendingGuestIntakeSync()) {
    return null;
  }

  const storedIntake = window.localStorage.getItem(GUEST_INTAKE_KEY);

  if (!storedIntake) {
    return null;
  }

  try {
    return JSON.parse(storedIntake);
  } catch {
    return null;
  }
}

export function clearPendingGuestIntakeState() {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.removeItem(CONTACT_FLOW_COMPLETED_KEY);
  window.localStorage.removeItem(GUEST_ONBOARDING_COMPLETED_KEY);
  window.localStorage.removeItem(GUEST_INTAKE_KEY);
  window.localStorage.removeItem(POST_AUTH_REDIRECT_KEY);
}
